import React from 'react';

const AlertSerbia = () => {
     
 return <>
            <h1>Obaveštenje o AKCIJI!</h1>
            <p>Cena jednog parfema iznosi:  <b>13.00 €</b></p>
            <p>Ukoliko odaberete <b>2 parfema</b>, parfem će vas koštati <b>10.00 €</b> </p>
            <p>U korpi će vam odmah biti izračunato u zavisnosti od toga koliko ste parfema odabrali.</p>
             <h2>Napomena !</h2>
            <p>Za Srbiju šaljemo iz distributivnog centra u Srbiji. Dostava 24h. Plaćanje u dinarima kuriru.</p>
        </>
}

export default AlertSerbia;